import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOMerkmalListStatus: 'idle',
    loadTOMerkmalListError: undefined as any,
    loadTOMerkmalListLastArgs: undefined as any,
    loadTOMerkmalStatus: 'idle',
    loadTOMerkmalError: undefined as any,
    saveTOMerkmalStatus: 'idle',
    saveTOMerkmalError: undefined as any,
    deleteTOMerkmalStatus: 'idle',
    deleteTOMerkmalError: undefined as any,

    toMerkmalList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOMerkmalList = createAsyncThunk('toMerkmalSlice/loadTOMerkmalList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toMerkmalSlice.loadTOMerkmalListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftmerkmal/?action=gte&MIN_TOID=${parentModel.HDR_ID}&MAX_TOID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOMerkmalListStatus } = getState().toMerkmalSlice
        return loadTOMerkmalListStatus !== 'pending'
    }
})

export const loadTOMerkmal = createAsyncThunk('toMerkmalSlice/loadTOMerkmal', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristomerkmal/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOMerkmalStatus } = getState().toMerkmalSlice
        return loadTOMerkmalStatus !== 'pending'
    }
})

export const saveTOMerkmal = createAsyncThunk('toMerkmalSlice/saveTOMerkmal', async ({ toMerkmal }: any, { rejectWithValue }: any) => {
    let promises = []
    if (toMerkmal?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristomerkmal/${ toMerkmal?.HDR_ID }/`,
            prepareData(toMerkmal),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristomerkmal/`,
            prepareData(toMerkmal),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOMerkmalStatus } = getState().toMerkmalSlice
        return saveTOMerkmalStatus !== 'pending'
    }
})

export const deleteTOMerkmal = createAsyncThunk('toMerkmalSlice/deleteTOMerkmal', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nuristomerkmal/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOMerkmalStatus } = getState().toMerkmalSlice
        return deleteTOMerkmalStatus !== 'pending'
    }
})

const ToMerkmalSlice = createSlice({
    name: 'toMerkmalSlice',
    initialState,
    reducers: {
        resetloadTOMerkmalListError: (state) => {
            state.loadTOMerkmalListError = undefined
        },
        resetloadTOMerkmal: (state) => {
            state.formItem = undefined
            state.loadTOMerkmalError = undefined
        },
        resetloadTOMerkmalError: (state) => {
            state.loadTOMerkmalError = undefined
        },
        resetsaveTOMerkmal: (state) => {
            state.formItem = undefined
            state.saveTOMerkmalError = undefined
        },
        resetsaveTOMerkmalError: (state) => {
            state.saveTOMerkmalError = undefined
        },
        resetdeleteTOMerkmalError: (state) => {
            state.deleteTOMerkmalError = undefined
        },
        removeFromToMerkmalListById: (state, action) => {
            state.toMerkmalList = state.toMerkmalList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromToMerkmalListByIds: (state, action) => {
            state.toMerkmalList = state.toMerkmalList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.toMerkmalList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOMerkmalListStatus = 'preloaded'
            state.loadTOMerkmalListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.toMerkmalList = []
            state.loadTOMerkmalListStatus = 'idle'
            state.loadTOMerkmalListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOMerkmalList.pending, (state) => {
            state.loadTOMerkmalListStatus = 'pending'
            state.loadTOMerkmalListError = undefined
        })
        builder.addCase(loadTOMerkmalList.fulfilled, (state, action) => {
            state.loadTOMerkmalListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOMerkmalListLastArgs = action.payload.args

            {
                state.toMerkmalList = action.payload.data

            }
        })
        builder.addCase(loadTOMerkmalList.rejected, (state, action) => {
            state.loadTOMerkmalListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOMerkmalListError = action.error.message
            } else {
                state.loadTOMerkmalListError = action.payload
            }
        })

        builder.addCase(loadTOMerkmal.pending, (state) => {
            state.loadTOMerkmalStatus = 'pending'
            state.loadTOMerkmalError = undefined
        })
        builder.addCase(loadTOMerkmal.fulfilled, (state, action) => {
            state.loadTOMerkmalStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toMerkmalList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toMerkmalList.push(newItem) }
                else { state.toMerkmalList[i] = { ...state.toMerkmalList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOMerkmal.rejected, (state, action) => {
            state.loadTOMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOMerkmalError = action.error.message
            } else {
                state.loadTOMerkmalError = action.payload
            }
        })

        builder.addCase(saveTOMerkmal.pending, (state) => {
            state.saveTOMerkmalStatus = 'pending'
            state.saveTOMerkmalError = undefined
        })
        builder.addCase(saveTOMerkmal.fulfilled, (state, action) => {
            state.saveTOMerkmalStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toMerkmalList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toMerkmalList.push(newItem) }
                else { state.toMerkmalList[i] = { ...state.toMerkmalList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOMerkmal.rejected, (state, action) => {
            state.saveTOMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOMerkmalError = action.error.message
            } else {
                state.saveTOMerkmalError = action.payload
            }
        })

        builder.addCase(deleteTOMerkmal.pending, (state) => {
            state.deleteTOMerkmalStatus = 'pending'
            state.deleteTOMerkmalError = undefined
        })
        builder.addCase(deleteTOMerkmal.fulfilled, (state, action) => {
            state.deleteTOMerkmalStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.toMerkmalList = state.toMerkmalList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.toMerkmalList = state.toMerkmalList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOMerkmal.rejected, (state, action) => {
            state.deleteTOMerkmalStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOMerkmalError = action.error.message
            } else {
                state.deleteTOMerkmalError = action.payload
            }
        })

    }
})

export const {
    resetloadTOMerkmalListError,
    resetloadTOMerkmal,
    resetloadTOMerkmalError,
    resetsaveTOMerkmal,
    resetsaveTOMerkmalError,
    resetdeleteTOMerkmalError,
    removeFromToMerkmalListById,
    removeFromToMerkmalListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ToMerkmalSlice.actions
export default ToMerkmalSlice.reducer
